module.exports = __webpack_public_path__ + "static/media/Dining area.3d263bd4.png";